var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bin, Delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.29036 18.5195V5.04036H2.08203V3.08203H6.89453V2.08203H13.082V3.08203H17.9154V5.04036H16.707V18.5195H3.29036ZM5.26953 16.5612H14.7279V5.04036H5.26953V16.5612ZM7.3737 14.9362H8.97786V6.6237H7.3737V14.9362ZM11.0195 14.9362H12.6445V6.6237H11.0195V14.9362ZM5.26953 5.04036V16.5612V5.04036Z",
    fill: "#BF3437"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlDeleteIcon);
export default __webpack_public_path__ + "static/media/bl-delete-icon.779c894d5f453e7242118073124319e2.svg";
export { ForwardRef as ReactComponent };